import React from 'react';
import classnames from 'classnames';

/**
 * Full-width grey section header band used inside the Order Details drawer.
 *
 * The drawer body has 24px (Tailwind spacing `6`) horizontal padding, so the
 * negative `-mx-6` pulls the band out to the body edges while `px-6` keeps the
 * label aligned with the surrounding content. This is a robust full-bleed that
 * matches the container padding exactly — replacing the old `-mx-4 w-[120%]`
 * hack that undershot the padding and overflowed horizontally.
 */
export default function OrderSectionHeader({ children, className }) {
  return <div className={classnames('-mx-6 px-6 py-2 bg-[#F5F6F5] website-text font-bold', className)}>{children}</div>;
}
